import React from "react";

export const ShowPassword = props => {
  const style = {
    ...props.style
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      style={style}
    >
      <mask
        id="mask0_1473_132633"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect
          x="0.191406"
          y="0.0761719"
          width="24"
          height="24"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_1473_132633)">
        <path
          d="M12.1978 14.976C13.1438 14.976 13.946 14.6448 14.6043 13.9825C15.2626 13.3203 15.5918 12.5161 15.5918 11.57C15.5918 10.624 15.2606 9.82181 14.5983 9.16348C13.9361 8.50514 13.132 8.17598 12.1858 8.17598C11.2398 8.17598 10.4376 8.50714 9.7793 9.16948C9.12096 9.83164 8.7918 10.6358 8.7918 11.582C8.7918 12.528 9.12296 13.3301 9.7853 13.9885C10.4475 14.6468 11.2516 14.976 12.1978 14.976ZM12.1918 14.276C11.4418 14.276 10.8043 14.0135 10.2793 13.4885C9.7543 12.9635 9.4918 12.326 9.4918 11.576C9.4918 10.826 9.7543 10.1885 10.2793 9.66348C10.8043 9.13848 11.4418 8.87598 12.1918 8.87598C12.9418 8.87598 13.5793 9.13848 14.1043 9.66348C14.6293 10.1885 14.8918 10.826 14.8918 11.576C14.8918 12.326 14.6293 12.9635 14.1043 13.4885C13.5793 14.0135 12.9418 14.276 12.1918 14.276ZM12.1953 17.776C10.1096 17.776 8.20846 17.2135 6.4918 16.0885C4.77513 14.9635 3.47513 13.4593 2.5918 11.576C3.47513 9.69264 4.77396 8.18848 6.4883 7.06348C8.20246 5.93848 10.1025 5.37598 12.1883 5.37598C14.274 5.37598 16.1751 5.93848 17.8918 7.06348C19.6085 8.18848 20.9085 9.69264 21.7918 11.576C20.9085 13.4593 19.6096 14.9635 17.8953 16.0885C16.1811 17.2135 14.2811 17.776 12.1953 17.776ZM12.1918 17.076C14.0751 17.076 15.8043 16.5801 17.3793 15.5885C18.9543 14.5968 20.1585 13.2593 20.9918 11.576C20.1585 9.89264 18.9543 8.55514 17.3793 7.56348C15.8043 6.57181 14.0751 6.07598 12.1918 6.07598C10.3085 6.07598 8.5793 6.57181 7.0043 7.56348C5.4293 8.55514 4.22513 9.89264 3.3918 11.576C4.22513 13.2593 5.4293 14.5968 7.0043 15.5885C8.5793 16.5801 10.3085 17.076 12.1918 17.076Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};
